// shipTrack.ts — Where each ship is DRAWN this frame (world space), so the camera can follow a
// selected ship. Ship.tsx (in-system hull) and ShipMarker.tsx (galaxy-map icon, mid-jump) write
// here at useFrame priority -1, i.e. before CameraRig's follow runs in the same frame, so the
// chase camera never lags a frame behind (the planet-follow jitter lesson). Plain mutable map —
// it changes every frame and must not trigger React renders.
import { Vector3 } from 'three';

export const shipTrack = new Map<string, Vector3>();

export function trackShip(id: string, world: Vector3): void {
  const v = shipTrack.get(id);
  if (v) v.copy(world);
  else shipTrack.set(id, world.clone());
}

export function untrackShip(id: string): void {
  shipTrack.delete(id);
}
